import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { format } from 'date-fns';

import { ViolationNote } from '../types';

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontFamily: 'Helvetica',
    color: '#333',
  },
  topSection: {
    display: 'flex',
    padding: 40,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 32,
    alignSelf: 'stretch',
  },
  bottomSection: {
    display: 'flex',
    paddingHorizontal: 40,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 23,
    alignSelf: 'stretch',
  },
  section: {
    marginBottom: 20,
  },
  label: {
    fontSize: 10,
    color: '#999999',
    marginBottom: 6,
  },
  nameRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  image: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 10,
  },
  displayName: {
    fontSize: 13,
    // fontWeight: 'bold',
    color: '#333333',
  },
  email: {
    fontSize: 12,
    color: '#555555',
    marginTop: 2,
  },
  designation: {
    fontSize: 11,
    color: '#999999',
    marginTop: 2,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
    width: '100%',
  },
  column: {
    flexDirection: 'column',
    width: '48%',
  },
  htmlText: {
    fontSize: 12,
    color: '#444444',
    lineHeight: 1.6,
  },
  smallText: {
    fontSize: 12,
    color: '#333333',
    marginTop: 4,
  },
});

export const PdfGeneration = ({ violationNote }: { violationNote: ViolationNote }) => {
  const { raisedBy, raisedFor, description, reportedTime, type } = violationNote ?? {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Top Section */}
        <View style={styles.topSection}>
          <View style={styles.section}>
            <Text style={styles.label}>Reported employee:</Text>
            <View style={styles.nameRow}>
              <Image style={styles.image} src={raisedFor?.profilePhoto} />
              <View style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={styles.displayName}>{raisedFor?.displayName}</Text>
                <Text style={styles.email}>{raisedFor?.email}</Text>
                <Text style={styles.designation}>{raisedFor?.designation}</Text>
              </View>
            </View>
          </View>

          <View style={styles.section}>
            <Text style={styles.label}>Reported by:</Text>
            <View style={styles.nameRow}>
              <Image style={styles.image} src={raisedBy?.profilePhoto} />
              <View style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={styles.displayName}>{raisedBy?.displayName}</Text>
                <Text style={styles.email}>{raisedBy?.email}</Text>
                <Text style={styles.designation}>{raisedBy?.designation}</Text>
              </View>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Date & time:</Text>
              <Text style={styles.email}>{format(new Date(reportedTime), 'PPP • p')}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Type</Text>
              <Text style={styles.email}>{type}</Text>
            </View>
          </View>

          <View style={styles.section}>
            <Text style={styles.label}>Description:</Text>
            <Text style={styles.htmlText}>{description}</Text>
          </View>
        </View>

        {/* Bottom Section */}
        <View style={styles.bottomSection}>
          <View style={styles.section}>
            <Text style={styles.label}>Acknowledgement:</Text>
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text style={{ color: 'transparent' }}>{'{{sign|1|*}}'}</Text>
              <Text style={styles.smallText}>{raisedFor?.displayName}</Text>
              <Text style={{ color: 'transparent' }}> {'{{date|1|*}}'}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
